module.exports = "<span lang=\"{{ current.lang }}\">{{ current.text }}</span>\r\n"